import { render, staticRenderFns } from "./CommunicationAdminV2.vue?vue&type=template&id=0895c589&scoped=true"
import script from "./CommunicationAdminV2.vue?vue&type=script&lang=js"
export * from "./CommunicationAdminV2.vue?vue&type=script&lang=js"
import style0 from "./CommunicationAdminV2.vue?vue&type=style&index=0&id=0895c589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895c589",
  null
  
)

export default component.exports